export const CLIENTS_FETCH = 'CLIENTS_FETCH';
export const CLIENTS_FETCH_ALL = 'CLIENTS_FETCH_ALL';
export const CLIENTS_IS_FETCING = 'CLIENTS_IS_FETCING';
export const CLIENTS_API = 'clients';
export const CLIENT_EDIT = 'CLIENT_EDIT';
export const CLIENT_SAVE = 'CLIENT_SAVE';
export const CLIENT_FILTER = 'CLIENT_FILTER';
export const SET_CLIENT_VIEW_FILTER = 'SET_CLIENT_VIEW_FILTER';
export const CLEAR_CLIENTS_LIST = 'CLEAR_CLIENTS_LIST';
export const SET_CLIENT_PROFILE = 'SET_CLIENT_PROFILE';
export const SET_CLIENT_IB = 'SET_CLIENT_IB';


// WEBPACK FOOTER //
// ./src/constants/clients.js